import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import "./index.scss";
import MapComponent from "components/Map/MapEsri";
import ProgressBar from "../../components/progress-bar/progress-bar.component";
import ListaTematica from "./lista-tematica";
import MapLegend from "./map-legend";
import SVGIcon from "../../components/Utils/svgIcons";
import LayersUtils from "../vista-tematicas-ambientales/LayersUtils";
class VistaMapas extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };
  static instanceCount = 0;
  constructor(props) {
    super(props);
    var me = this;
    this.mapref = React.createRef();
    VistaMapas.instanceCount++;
    me.instanceId = VistaMapas.instanceCount;
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      layers: [],
      dataLayer: [],
      modal: false,
      loading: true,
      showBaseMap: false,
      showLegend: true,
      showMenuLeft: true,
      md_col_size: 4,
      dataLegend: []
    };
    this.selectLayerChange = this.selectLayerChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleClickLayerToogle = this.handleClickLayerToogle.bind(this);
    this.handleClickLayerLegend = this.handleClickLayerLegend.bind(this);
    this.handleClickMenuLeft = this.handleClickMenuLeft.bind(this);
    this.handleClickCleanMap = this.handleClickCleanMap.bind(this);
  }
  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }
  selectLayerChange(event) {
    let me = this;
    let new_store = [];
    let found = false;
    me.state.dataLegend.forEach(item => {
      if (item.id === event.id) {
        new_store.push(event);
        found = true;
      } else {
        new_store.push(item);
      }
    });
    if (!found) {
      new_store.push(event);
    }
    this.setState({
      dataLayer: [event],
      dataLegend: new_store
    });
  }
  getMapLayerId() {
    return "map-geo-" + this.instanceId;
  }
  getMapLegendId() {
    return "map-legend-" + this.instanceId;
  }
  componentDidMount() {
    const me = this;
    me.mounted = true;
    LayersUtils.getAllLayers(function (data, response) {
      if (me.mounted) {
        if (response) {
          me.setState({
            layers: data.layers,
            dataLayer: data.dataLayer,
            dataLegend: data.dataLegend,
            loading: false
          });
        } else {
          me.setState({
            loading: false
          });
        }
      }
    });
  }
  componentWillUnmount() {
    let me = this;
    me.mounted = false;
  }
  handleClickLayerToogle(e) {
    e.preventDefault();
    let isVisible = this.state.showBaseMap;
    isVisible = !isVisible;
    this.setState({
      showBaseMap: isVisible
    });
  }
  handleClickLayerLegend(e) {
    e.preventDefault();
    let isVisible = this.state.showLegend;
    isVisible = !isVisible;
    this.setState({
      showLegend: isVisible
    });
  }
  handleClickMenuLeft(e) {
    e.preventDefault();
    let isVisible = this.state.showMenuLeft;
    isVisible = !isVisible;
    this.setState({
      showMenuLeft: isVisible,
      md_col_size: isVisible ? 4 : 12
    });
  }
  handleClickCleanMap(e) {
    e.preventDefault();
    let new_store = [];
    this.state.dataLegend.forEach(item => {
      if (item.checked) {
        let new_item = Object.assign([], item);
        new_item.checked = false;
        new_item.init = false;
        new_store.push(new_item);
      }
    });
    this.setState({
      dataLayer: new_store,
      dataLegend: new_store
    });
    if (document.querySelectorAll(".accordion-item__content input").length) {
      document.querySelectorAll(".accordion-item__content input").forEach(function (item, key) {
        item.checked = false;
      });
    }
  }
  renderMap() {
    if (this.state.status === "loading") {
      return <h1>loading</h1>;
    }
  }
  render() {
    let me = this;
    const {
      layers,
      dataLayer,
      dataLegend,
      loading,
      showBaseMap,
      showLegend,
      showMenuLeft,
      md_col_size
    } = this.state;
    if (this.state.view) {
      this.state.view.goTo([-75.074387, -10.39665]);
    }
    let instanceLayerMap = me.getMapLayerId();
    let instanceLegendMap = me.getMapLegendId();
    return (
      <div>
        <Row>
          <Col
            xs={12}
            sm={12}
            md={12}
            xl={md_col_size}
            style={{ display: showMenuLeft ? "block" : "none" }}
          >
            <Card className="card-border-line">
              <CardHeader className="card-header-boder-bottom-line">
                <Row>
                  <Col>
                    <div>
                      <h5>Temática ambiental</h5>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="mb-1">
                  <ProgressBar active={loading} aniTime={"1"} />
                </div>
                <Row>
                  <Col>
                    <ListaTematica
                      onChange={this.selectLayerChange}
                      items={layers}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={12} xl={12 - md_col_size}>
            <Card className="card-border-line">
              <CardHeader className="card-header-boder-bottom-line">
                <Row>
                  <Col xs={12} sm={12} md={12} xl={12}>
                    <div>
                     <h5> Capas geográficas</h5>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="map-component-view" id="map-component-view" >
                  <div className="control-panel shadow">
                    <ul className="control-panel__list">
                      <li
                        className="control-panel__zoom-out pointer"
                        title={"Limpiar capas"}
                        onClick={this.handleClickCleanMap}
                      >
                        <SVGIcon id={"icon-reset"} />
                      </li>
                      <li
                        className="control-panel__zoom-in pointer"
                        title={"Ver capas base"}
                        onClick={this.handleClickLayerToogle}
                      >
                        <SVGIcon id={"icon-basemap"} />
                      </li>
                      <li
                        className="control-panel__share-map pointer"
                        title={showMenuLeft ? "Ampliar Mapa" : "Reducir Mapa"}
                        onClick={this.handleClickMenuLeft}
                      >
                        {showMenuLeft ? (
                          <SVGIcon id={"icon-map-zoom"} />
                        ) : (
                            <SVGIcon id={"icon-map-minus"} />
                          )}
                      </li>
                      <li
                        className="control-panel__share-map pointer"
                        title={"Ver Legenda"}
                        onClick={this.handleClickLayerLegend}
                      >
                        <SVGIcon id={"icon-legend"} />
                      </li>
                    </ul>
                  </div>
                  <div
                    className="control-map-base"
                    style={{ display: showBaseMap ? "block" : "none" }}
                  >
                    <div id={instanceLayerMap} className="control-map-base__panel"></div>
                  </div>
                  <MapComponent dataLayer={dataLayer} layerBaseName={instanceLayerMap} legendName={instanceLegendMap} ref={this.mapref} />
                  <div className="legend-panel">
                    <div
                      className="legend-panel__title"
                      onClick={this.handleClickLayerLegend}
                    >
                      <span>Leyenda</span>
                      <span
                        className="legend-panel__category-caret"
                        style={{ display: showLegend ? "block" : "none" }}
                      >
                        ▼
                      </span>
                      <span
                        className="legend-panel__category-caret"
                        style={{ display: showLegend ? "none" : "block" }}
                      >
                        ▲
                      </span>
                    </div>
                    <div
                      className="legend-panel__layers"
                      style={{ display: showLegend ? "block" : "none" }}
                    >
                      <div>
                        <MapLegend data={dataLegend} />
                        <div id={instanceLegendMap}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div >
    );
  }
}

export default VistaMapas;
